import { BaseModel } from '../email-template/base-model.interface';
import BlockModel from '../email-template/block-model.interface';
import { NotificationInitVariables } from '../template/notifications-model.interface';

export interface MetaCarouselAccountTypeModel extends BaseModel {
  variables?: { [key: string]: string } | MetaCarouselAccountTypeVariables;
}

export interface MetaCarouselAccountTypeVariables {
  AccountType: string;
}

export class MetaCarouselAccountTypeInitVariables implements MetaCarouselAccountTypeVariables {
  AccountType = '';
}

export class MetaCarouselAccountTypeInitModel implements BlockModel {
  blockId: string = '';
  count: number = 0;
  name: string = '';
  variables: { [key: string]: string };
  notifications: NotificationInitVariables[];

  constructor() {
    const initVars = new MetaCarouselAccountTypeInitVariables();
    this.variables = { ...initVars };
    this.notifications = [new NotificationInitVariables()];
  }
}
